import React from 'react';
import { EventTrackingContextType } from './types';

export const EventTrackingContext = React.createContext<
  EventTrackingContextType | undefined
>(undefined);
